import React, { Fragment, useContext } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import ConfigControl from '../../../components/ConfigControl';
import { FieldsMode, MonitorConfig } from '../../../helpers/constants';
import MonitorContext from '../MonitorContext';
import Cell from './common/Cell';
import DataCell from './common/DataCell';
import MonitorField from './common/MonitorField';
import MonitorLabel from './common/MonitorLabel';
import Row from './common/Row';
import UnitContainer from './common/UnitContainer';

export interface IWorkModeAreaProps {
  currentConfig: string;
}
const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
`;
const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 49%;
`;
const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 49%;
`;
const CellContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export default function SpareArea({ currentConfig }: IWorkModeAreaProps) {
  const { spareAreaMode } = useSelector(
    (state: any) => state.executor.s80.monitorFieldModes
  );
  const { monitor: presentMonitor } = useContext(MonitorContext);
  const monitorSpareAreaMode = spareAreaMode[presentMonitor];
  return (
    <Fragment>
      <ConfigControl elementFor={MonitorConfig.TACTICO} config={currentConfig}>
        <ConfigControl
          elementFor={FieldsMode.PERISCOPE}
          config={monitorSpareAreaMode}
        >
          <Container>
            <LeftContainer>
              <CellContainer>
                <Cell width="40%">
                  <MonitorLabel field="spare-area-periscope-1" />
                </Cell>
                <DataCell width="60%">
                  <MonitorField field="spare-area-periscope-1" />
                </DataCell>
              </CellContainer>
              <CellContainer>
                <Cell width="40%">
                  <MonitorLabel field="spare-area-periscope-2" />
                </Cell>
                <DataCell width="60%">
                  <MonitorField field="spare-area-periscope-2" />
                </DataCell>
              </CellContainer>
              <CellContainer>
                <Cell width="40%">
                  <MonitorLabel field="spare-area-periscope-3" />
                </Cell>
                <DataCell width="60%">
                  <MonitorField field="spare-area-periscope-3" />
                </DataCell>
              </CellContainer>
              <CellContainer>
                <Cell width="40%">
                  <MonitorLabel field="spare-area-periscope-4" />
                </Cell>
                <DataCell width="60%">
                  <MonitorField field="spare-area-periscope-4" />
                </DataCell>
              </CellContainer>
            </LeftContainer>
            <RightContainer>
              <CellContainer>
                <Cell width="40%">
                  <MonitorLabel field="spare-area-periscope-5" />
                </Cell>
                <DataCell width="60%">
                  <MonitorField field="spare-area-periscope-5" />
                </DataCell>
              </CellContainer>
              <CellContainer>
                <Cell width="40%">
                  <MonitorLabel field="spare-area-periscope-6" />
                </Cell>
                <DataCell width="60%">
                  <MonitorField field="spare-area-periscope-6" />
                </DataCell>
              </CellContainer>
            </RightContainer>
          </Container>
        </ConfigControl>

        <ConfigControl
          elementFor={FieldsMode.RADAR_LINK}
          config={monitorSpareAreaMode}
        >
          <Container>
            <LeftContainer>
              <CellContainer>
                <Cell width="35%">
                  <MonitorLabel field="spare-area-radar-link-1" />
                </Cell>
                <DataCell width="50%">
                  <MonitorField field="spare-area-radar-link-1" />
                </DataCell>
                <UnitContainer field="spare-area-radar-link-1" />
              </CellContainer>
              <CellContainer>
                <Cell width="35%">
                  <MonitorLabel field="spare-area-radar-link-2" />
                </Cell>
                <DataCell width="50%">
                  <MonitorField field="spare-area-radar-link-2" />
                </DataCell>
                <UnitContainer field="spare-area-radar-link-2" />
              </CellContainer>
              <CellContainer>
                <Cell width="35%">
                  <MonitorLabel field="spare-area-radar-link-3" />
                </Cell>
                <DataCell width="50%">
                  <MonitorField field="spare-area-radar-link-3" />
                </DataCell>
                <UnitContainer field="spare-area-radar-link-3" />
              </CellContainer>
              <CellContainer>
                <Cell width="35%">
                  <MonitorLabel field="spare-area-radar-link-4" />
                </Cell>
                <DataCell width="50%">
                  <MonitorField field="spare-area-radar-link-4" />
                </DataCell>
                <UnitContainer field="spare-area-radar-link-4" />
              </CellContainer>
            </LeftContainer>
            <RightContainer>
              <CellContainer>
                <Cell width="35%">
                  <MonitorLabel field="spare-area-radar-link-5" />
                </Cell>
                <DataCell width="60%">
                  <MonitorField field="spare-area-radar-link-5" />
                </DataCell>
              </CellContainer>
              <CellContainer>
                <Cell width="35%">
                  <MonitorLabel field="spare-area-radar-link-6" />
                </Cell>
                <DataCell width="60%">
                  <MonitorField field="spare-area-radar-link-6" />
                </DataCell>
              </CellContainer>
            </RightContainer>
          </Container>
        </ConfigControl>
      </ConfigControl>
      <ConfigControl
        elementFor={[MonitorConfig.LINK, MonitorConfig.SISTEMA]}
        config={currentConfig}
      >
        <Row>
          <Cell width="30%"></Cell>
          <DataCell width="56%"></DataCell>
        </Row>
        <Row>
          <Cell width="30%"></Cell>
          <DataCell width="56%"></DataCell>
        </Row>
        <Row>
          <Cell width="30%"></Cell>
          <DataCell width="56%"></DataCell>
        </Row>
        <Row>
          <Cell width="30%"></Cell>
          <DataCell width="56%"></DataCell>
        </Row>
      </ConfigControl>
    </Fragment>
  );
}
